export type SnackbarType =  'SUCCESS' | 'ERROR' | 'INFO' | 'WARNING';

export interface SnackbarData {
  text: string;
  type?: SnackbarType;
  buttonText?: string;
  hideButton?: boolean;
}
